import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck } from "lucide-react";

/**
 * Compact About teaser block used on Suburb landing pages.
 * Drives SEO internal linking back to /about and reinforces independence positioning.
 */
export function AboutMini({ suburb }) {
  return (
    <section className="py-14 lg:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="rounded-3xl bg-slate-50 border border-slate-100 p-8 lg:p-12 grid lg:grid-cols-12 gap-8 items-center"
        >
          <div className="lg:col-span-1 flex lg:justify-center">
            <div className="w-14 h-14 rounded-2xl bg-slate-900 flex items-center justify-center">
              <ShieldCheck className="w-7 h-7 text-cyan-400" />
            </div>
          </div>
          <div className="lg:col-span-8">
            <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-cyan-600">Local water testing lab</span>
            <h2 className="font-display mt-2 text-2xl lg:text-3xl font-bold text-slate-900 leading-[1.15]">
              {suburb ? `Why ${suburb} residents trust us` : "Why locals trust us"}
            </h2>
            <p className="mt-3 text-[15px] text-slate-600 leading-relaxed">
              Aware Water Testing is independently operated from our Noosaville lab. We don't sell water filters or treatment systems — our recommendations are driven by your water, not a product catalogue. When treatment is genuinely needed, we connect customers with Pristine Water Systems Sunshine Coast specialists.
            </p>
          </div>
          <div className="lg:col-span-3 lg:text-right">
            <Link
              to="/about"
              data-testid="about-mini-link"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800 transition-colors"
            >
              Learn about us <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
